export default __webpack_public_path__ + "static/media/max-boutique.0c91d471.png";